import { makeStyles } from '@material-ui/core/styles';
import { COLORS, SPACING } from '../constants';

export const useStyles = makeStyles(() => ({
  formGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: SPACING.formRowGap,
    marginBottom: SPACING.formGroupGap,
  },
  toggleRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0 24px',
    alignItems: 'center',
    marginBottom: SPACING.formGroupGap,
  },
  kvSection: {
    marginBottom: SPACING.formGroupGap,
  },
  kvHelpText: {
    fontSize: 12,
    color: COLORS.muted,
    marginBottom: 6,
  },
  kvRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr auto',
    gap: SPACING.formRowGap,
    alignItems: 'start',
    marginBottom: 8,
  },
  summaryRow: {
    display: 'flex',
    gap: 10,
    fontSize: 12,
    color: COLORS.muted,
    flexWrap: 'wrap',
  },
  staticFieldLabel: {
    fontSize: 12,
    color: COLORS.muted,
    marginBottom: 4,
  },
  staticFieldValue: {
    fontSize: 14,
    color: COLORS.body,
  },
  compactGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: SPACING.formRowGap,
    marginBottom: 12,
  },
  toggleRowNoMargin: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0 24px',
    alignItems: 'center',
  },
}));
